import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { RidangoReduxAction, Ticket } from '@ridango/core';

import { Observable } from 'rxjs';

import { PurchaseHistoryService } from '../purchase-history.service';
import { PurchaseHistoryActions } from './purchase-history.actions';
import { PurchaseHistoryPartialStoreState } from './purchase-history.reducer';
import * as PurchaseHistorySelectors from './purchase-history.selectors';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PurchaseHistoryFacade {
    tickets$: Observable<Ticket[]> = this.store.select(PurchaseHistorySelectors.getPurchaseHistory);
    loading$: Observable<boolean> = this.store.select(PurchaseHistorySelectors.getPurchaseHistoryLoading);
    startDate$: Observable<Date> = this.store.select(PurchaseHistorySelectors.getStartDate);
    endDate$: Observable<Date> = this.store.select(PurchaseHistorySelectors.getEndDate);
    minStartDate$: Observable<Date> = this.store.select(PurchaseHistorySelectors.getMinStartDate);
    minEndDate$: Observable<Date> = this.store.select(PurchaseHistorySelectors.getMinEndDate);
    maxStartDate$: Observable<Date> = this.store.select(PurchaseHistorySelectors.getMaxStartDate);
    maxEndDate$: Observable<Date> = this.store.select(PurchaseHistorySelectors.getMaxEndDate);
    diff$: Observable<number> = this.store.select(PurchaseHistorySelectors.getDateDiff);

    constructor(
        private store: NgRedux<PurchaseHistoryPartialStoreState>,
        private service: PurchaseHistoryService,
        private actions: PurchaseHistoryActions,
        private translate: TranslateService
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    setTickets(payload) {
        this.dispatch(this.actions.setTickets(payload));
    }

    setCarts(payload) {
        this.dispatch(this.actions.setCarts(payload));
    }

    async getPdfPut(jwt_token: string, ticketId?: string) {
        await this.service.getPdfPut(jwt_token, undefined, ticketId);
    }

    fetchPurchaseHistory() {
        return this.dispatch(this.actions.fetchPurchaseHistory());
    }

    getPdf(lang: string, token: string = null) {
        return this.service.getPdf(lang, token);
    }

    setStartDate(date: Date) {
        return this.dispatch(this.actions.setStartDate(date));
    }

    setEndDate(date: Date) {
        return this.dispatch(this.actions.setEndDate(date));
    }
}
